import * as pdfMake from "pdfmake/build/pdfmake";
import * as pdfFonts from "pdfmake/build/vfs_fonts";
import {
  Content,
  DynamicContent,
  TDocumentDefinitions,
} from "pdfmake/interfaces";

(<any>pdfMake).addVirtualFileSystem(pdfFonts);

interface generatePDFProps {
  filename?: string;
  header?: DynamicContent | Content | undefined | undefined;
  content?: Content[];
  footer?: DynamicContent | Content | undefined | undefined;
}

const generatePDF = async ({
  filename,
  header,
  content,
  footer,
}: generatePDFProps) => {
  // Title
  const pdfHeader: DynamicContent | Content | undefined = header;

  const pdfContent: Content[] = content || [];
  // Footer
  const pdfFooter: DynamicContent | Content | undefined = footer;

  // Definitions
  const docDefinition: TDocumentDefinitions = {
    pageSize: "A4",
    pageMargins: [40, 60, 40, 20],

    header: pdfHeader,
    content: pdfContent,
    footer: pdfFooter,
  };

  pdfMake.createPdf(docDefinition).download(`${filename}.pdf`);
};

export default generatePDF;
